const createWireTransferStyle = {
	
};

export default createWireTransferStyle;
